<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top border :menuName="infoShow?'提示信息':(next?'确认验证码':'验证手机号')" :prevUrl="infoShow||!next?'/WeChat/Person/Account/Phone':'/WeChat/Person/Account'">
		</Layout-Top>
	<!-- 	<Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="22">
				{{infoShow?'提示信息':(next?'确认验证码':'验证手机号')}}
			</Col>
		</Row>
		<Divider style="margin-top: 0px;height: 2px;" /> -->
		<div v-if="!next&&!infoShow" id="prev" style="height: 100%;width: 100%;">
			<div style="height: 80px;width: 100%;color:#c5c8ce;text-align: center;">
				温馨提示:一个手机号只能绑定一个账号
			</div>
			<Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; line-height: 46px;">
				<Col span="4">
				</Col>
				<Col span="16" style="text-align: center;">
					<input ref="pphone" v-model="person.phone" style="height: 42px;font-size: 32px;text-align: center;background: #eceef1;height: 36px;width: 100%;border-bottom:1px solid #aCCaCC ;border-top: none;border-left: none;border-right: none;outline: none;" maxlength="11" :type="person.phone.length==11?'text':'number'" placeholder="输入本人手机号" />
				</Col>
				<Col span="4">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; line-height: 46px;margin-top: 38px;">
				<Col span="6">
				</Col>
				<Col span="12" style="text-align: center;">
					<Button @click="nextYzm" type="info" long>下一步</Button>
				</Col>
				<Col span="6">
				</Col>
			</Row>
		</div>
		<div v-if="next&&!infoShow" id="next" style="width: 100%;padding-top: 120px;">
			<div style="height: 66px;width: 100%;color:#c5c8ce;text-align: center;">
				请将手机收到的6位数字验证码填入框中
			</div>
			<Row type="flex" justify="center" align="center">
				<Col span="5">
				</Col>
				<Col span="14" style="text-align: center;">
					<Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; line-height: 46px;">
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input1" autofocus ref="input1" size="large" :type="inputArr.input1.length==1?'text':'number'" maxlength="1" class="inputK" style="text-align: center;" />
						</Col>
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input2" autofocus ref="input2" size="large" :type="inputArr.input2.length==1?'text':'number'" maxlength="1" class="inputK" />
						</Col>
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input3" autofocus ref="input3" size="large" :type="inputArr.input3.length==1?'text':'number'" maxlength="1" class="inputK" />
						</Col>
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input4" autofocus ref="input4" size="large" :type="inputArr.input4.length==1?'text':'number'" maxlength="1" class="inputK" />
						</Col>
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input5" autofocus ref="input5" size="large" :type="inputArr.input5.length==1?'text':'number'" maxlength="1" class="inputK" />
						</Col>
						<Col span="4" style="text-align: center;">
							<Input v-model="inputArr.input6" autofocus ref="input6" size="large" :type="inputArr.input6.length==1?'text':'number'" maxlength="1" class="inputK" />
						</Col>
					</Row>
				</Col>
				<Col span="5">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="height: 56px;margin-top: 65px;">
				<Col span="8">
				</Col>
				<Col span="8">
					<Button @click="infoShow=true" type="success" long>验证</Button>
				</Col>
				<Col span="8">
				</Col>
			</Row>
		</div>
		
		<div v-if="infoShow" style="width: 100%;padding-top: 180px;">
			<div style="height: 100px;width: 100%;margin: 0 auto;text-align: center;font-size: 16px;">
				<Icon style="margin-bottom: 18px;" :color="bindingSuccess?'#19be6b':'#ed4014'" size="88" :type="bindingSuccess?'ios-checkmark-circle':'ios-close-circle'" /><br>
				{{bindingSuccess?'绑定成功':'输入错误验证码超过5次，请稍后重试'}}
			</div>
		</div>
	</div>
	
</template>
<script>
	import Top from '../../../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				person:{
					phone:''
				},
				next:false,
				infoShow:false,
				bindingSuccess:true,
				inputArr:{
					input1:'',
					input2:'',
					input3:'',
					input4:'',
					input5:'',
					input6:''
				}
			}
		},
		created:function(){
		},
		methods:{
			nextYzm(){
				if(this.person.phone.length!=11){
					 this.$Notice.open({
						title: '手机号错误提示',
						desc: '请输入正确的11位的手机号码'
					});
					return;
				}
				this.next=true;
				this.$refs.input1.focus();
			}
		},
		watch:{
			'inputArr.input1':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==1){
						this.$refs.input2.focus();
					  }
	　　　　　　　}
			},
			'inputArr.input2':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==1){
						this.$refs.input3.focus();
					  }else{
							this.$refs.input1.focus();
					  }
	　　　　　　　}
			},
			'inputArr.input3':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==1){
						this.$refs.input4.focus();
					  }else{
							this.$refs.input2.focus();
					  }
	　　　　　　　}
			},
			'inputArr.input4':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==1){
						this.$refs.input5.focus();
					  }else{
							this.$refs.input3.focus();
					  }
	　　　　　　　}
			},
			'inputArr.input5':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==1){
							this.$refs.input6.focus();
					  }else{
							this.$refs.input4.focus();
					  }
	　　　　　　　}
			},
			'inputArr.input6':{
				handler(curVal,oldVal){
	　　　　　　　　　　if(curVal.length==0){
							this.$refs.input5.focus();
					  }
	　　　　　　　}
			}
		}
	}
</script>
<style>
	.inputK{
		width: 32px;
	}
	.ivu-input{
		text-align: center;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Account/Phone/Binding/index.vue